import React from "react";

import Layout from '@components/layout';
import CancellationPoliciesTemplate from "@components/cancellationPoliciesPage/cancellationPoliciesTemplate";

const IndexPage = ({ pageContext }) => (
  <Layout locale={pageContext.locale}>
    <CancellationPoliciesTemplate pageContext={pageContext} />
  </Layout>
);

export default IndexPage;
